import React from "react"
import Layout from "../components/layout"
import Main from "../components/Main"
import SEO from "../components/seo"

const IndexPage = () => (
  <Layout>
    <SEO title="Полный Курс по React JS для начинающих (обзор курса, причины популярности React, ReactDOM и JSX)" />
    <Main />
  </Layout>
)

export default IndexPage
